import React from 'react'

class ViewToggleTab extends React.Component {
  handleClick() {
      return this.props.handleTabChange(this.props.tab);
  }
  
  render() {
      return (
        <td className={this.props.classname} onClick={this.handleClick.bind(this)}>
          <span>
            <i className={this.props.icon}/>
          </span>
          <span>
            {this.props.text}
          </span>
        </td>
      )
    }
} 

export default ViewToggleTab

